<template>
  <form class="space-y-16" @submit.prevent="onSubmit">
    <ValidationProvider name="roleIds" vid="roleIds" slim v-slot="{ errors, failed }">
      <div class="space-y-4">
        <div v-for="role in roles" :key="role.id" class="flex">
          <div class="flex-1">
            {{ role.name }}
          </div>
          <div class="flex-none">
            <label class="label custom-checkbox">
              <input
                type="checkbox"
                name="roleIds"
                @input="handleCheckbox($event, role.id)"
                :checked="formData.roleIds.indexOf(role.id) >= 0"
                :disabled="submitting"
              />
              <span />
            </label>
          </div>
        </div>
        <p v-if="failed" class="msg error">
          {{ errors[0] }}
        </p>
      </div>
    </ValidationProvider>
    <div>
      <BaseButton primary :disabled="submitting"> Submit </BaseButton>
    </div>
  </form>
</template>

<script>
import { entityComputed } from '@/store/helper';

export default {
  name: 'RolesForm',
  props: {
    submitting: Boolean,
    userRoleIds: {
      type: Array,
      required: true,
    },
    roles: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        roleIds: [...this.userRoleIds],
      },
    };
  },
  computed: {
    ...entityComputed,
  },
  methods: {
    handleCheckbox(ev, roleId) {
      const { checked } = ev.target;
      if (checked) {
        this.formData.roleIds = [...this.formData.roleIds, roleId];
      } else {
        this.formData.roleIds = [...this.formData.roleIds.filter((id) => id !== roleId)];
      }
    },
    onSubmit() {
      this.$emit('submit', this.formData);
    },
  },
};
</script>
